if (!customElements.get('product-form')) {
    customElements.define(
        'product-form',
        class ProductForm extends HTMLElement {
            constructor() {
                super();

                this.form = this.querySelector('form');
                this.variantIdInput.disabled = false;
                this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
                this.cart = document.querySelector('cart-drawer');
                this.submitButton = this.querySelector('[type="submit"]');
                this.submitButtonText = this.submitButton.querySelector('span');

                if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

                this.hideErrors = this.dataset.hideErrors === 'true';
            }

            onSubmitHandler(evt) {
                evt.preventDefault();
                if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

                this.handleErrorMessage();

                this.submitButton.setAttribute('aria-disabled', true);
                this.submitButton.classList.add('loading');
                this.querySelector('.loading__spinner')?.classList.remove('hidden');

                const config = fetchConfig('javascript');
                config.headers['X-Requested-With'] = 'XMLHttpRequest';
                config.headers['Content-Type'] = 'application/json';
                config.body = {};

                const formData = new FormData(this.form);
                if (this.cart) {
                    config.body['sections'] = this.cart.getSectionsToRender().map((section) => section.id);
                    config.body['sections_url'] = window.location.pathname;
                    this.cart.setActiveElement(document.activeElement);
                }

                config.body['items'] = [
                    {
                        id: formData.get('id'),
                        selling_plan: formData.get('selling_plan') || undefined,
                        quantity: formData.get('quantity') || 1,
                    },
                ];

                if (this.dataset.additionalBehavior === 'addSubscription') {
                    const additionalProducts = formData.getAll('additional-id');
                    for (const additionalProductId of additionalProducts) {
                        config.body['items'].push({
                            id: additionalProductId,
                            quantity: 1,
                        });
                    }
                } else if (this.dataset.additionalBehavior === 'addPack') {
                    const additionalProducts = formData.getAll('additional-pack-id');
                    for (const additionalProductId of additionalProducts) {
                        config.body['items'].push({
                            id: additionalProductId,
                            quantity: 1,
                        });
                    }
                }

                config.body = JSON.stringify(config.body);

                fetch(`${routes.cart_add_url}`, config)
                    .then((response) => response.json())
                    .then((response) => {
                        if (response.status) {
                            publish(PUB_SUB_EVENTS.cartError, {
                                source: 'product-form',
                                productVariantId: formData.get('id'),
                                errors: response.errors || response.description,
                                message: response.message,
                            });
                            this.handleErrorMessage(response.description);

                            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
                            if (!soldOutMessage) return;
                            this.submitButton.setAttribute('aria-disabled', true);
                            this.submitButtonText.classList.add('hidden');
                            soldOutMessage.classList.remove('hidden');
                            this.error = true;
                            return;
                        } else if (!this.cart) {
                            window.location = window.routes.cart_url;
                            return;
                        }

                        if (!this.error)
                            publish(PUB_SUB_EVENTS.cartUpdate, {
                                source: 'product-form',
                                productVariantId: formData.get('id'),
                                cartData: response,
                            });
                        this.error = false;
                        const quickAddModal = this.closest('quick-add-modal');
                        const dontOpenCart = window.dontOpenCart === true;
                        if (quickAddModal) {
                            document.body.addEventListener(
                                'modalClosed',
                                () => {
                                    setTimeout(() => {
                                        this.cart.renderContents(response, !dontOpenCart);
                                    });
                                },
                                { once: true }
                            );
                            quickAddModal.hide(true);
                        } else {
                            this.cart.renderContents(response, !dontOpenCart);
                        }

                        window.dontOpenCart = null;
                    })
                    .catch((e) => {
                        console.error(e);
                    })
                    .finally(() => {
                        this.submitButton.classList.remove('loading');
                        if (this.cart && this.cart.classList.contains('is-empty'))
                            this.cart.classList.remove('is-empty');
                        if (!this.error) this.submitButton.removeAttribute('aria-disabled');
                        this.querySelector('.loading__spinner')?.classList.add('hidden');
                        if (window.callbackLocation) {
                            window.location = window.callbackLocation;
                        } else if (window.currentDrawer) {
                            window.currentDrawer.close(false);
                            window.currentDrawer = null;
                        }

                        if (window.callbackAction) {
                            window.callbackAction();
                            window.callbackAction = null;
                        }
                    });
            }

            handleErrorMessage(errorMessage = false) {
                this.errorMessageWrapper =
                    this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
                if (!this.errorMessageWrapper) return;
                this.errorMessage =
                    this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

                this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

                if (errorMessage) {
                    this.errorMessage.textContent = errorMessage;
                }
            }

            toggleSubmitButton(disable = true, text) {
                if (disable) {
                    this.submitButton.setAttribute('disabled', 'disabled');
                    if (text) this.submitButtonText.textContent = text;
                } else {
                    this.submitButton.removeAttribute('disabled');
                    this.submitButtonText.textContent = window.variantStrings.addToCart;
                }
            }

            get variantIdInput() {
                return this.form.querySelector('[name=id]');
            }
        }
    );
}
